
import { Component, Vue } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';
import { TSiteConfigState } from '~/store/types';
import { IProfileState } from '~/store/profile/types';

interface ICta {
  text: string;
  href: string;
  requirement: boolean;
}

@Component
export default class NodesHeroVideo extends Vue {
  @Getter('siteConfig')
  readonly siteConfigState!: TSiteConfigState;

  @State((profile: IProfileState) => profile.user.loggedIn, {
    namespace: 'profile',
  })
  loggedIn!: boolean;

  get shouldShowFilmNodeBuyPage() {
    return this.siteConfigState?.data?.shouldShowFilmNodeBuyPage || false;
  }

  get ctaPrimary(): ICta | undefined {
    return {
      text: this.$t('common.cta.buyNode') as string,
      href: `/nodes/film-node/buy`,
      requirement: this.shouldShowFilmNodeBuyPage,
    };
  }

  get ctaSecondary(): ICta | undefined {
    // return {
    //   text: `Exchange Film Pass`,
    //   href:
    //     '/inventory/nfts/item?id=0x036e00000000000000000000000000000000&network=ETHEREUM&collection=Gala%20Film',
    //   requirement: this.loggedIn,
    // };

    return undefined;
  }

  get showCtas() {
    return this.ctaPrimary?.requirement || this.ctaSecondary?.requirement;
  }
}
